/**
 * Returns the distance between two geographic coordinates in kilometers
 * @param {number} lat1 - latitude of point 1
 * @param {number} lon1 - longitude of point 1
 * @param {number} lat2 - latitude of point 2
 * @param {number} lon2 - longitude of point 2
 * @returns {number} distance in kilometers
 */
const distanceBetween = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the Earth in km
  const toRad = (value) => (value * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // distance in km
};

export default distanceBetween;
